module.exports = __webpack_public_path__ + "static/media/table2.17c39d15.png";